import { IApiResponse } from '@/types';
import { IRequestError } from '@/types/error';
import { AxiosResponse } from 'axios';

/**
 * Wraps an Axios HTTP call and throws an error for anything outside the 200-range of HTTP statuses
 */
export function wrapAxiosRequest<T>(request: Promise<AxiosResponse<T>>): Promise<IApiResponse<T>> {
  return request
    .then((response: AxiosResponse<T>) => {
      if (response.status < 200 || response.status > 299) {
        throw new Error(response.statusText);
      }
      return {
        data: response.data,
        headers: response.headers,
      };
    })
    .catch((err: IRequestError) => {
      console.error(err);
      throw err;
    });
}
